import { setupReceiptUploadInvalidationListener } from 'app-components/store/listeners';

import { receiptUploadCoordinator } from 'containers/ReceiptCenter/receiptUploadCoordinator';

import { startAppListening } from './listenerMiddleware';

setupReceiptUploadInvalidationListener(startAppListening, receiptUploadCoordinator.invalidate);
